<nav class="lh-breadcrumb" *ngIf="items.length" [attr.aria-label]="'learningHub.breadcrumb' | lhTranslate: lang">
  <ol>
    <li *ngFor="let item of items; let last = last" class="lh-breadcrumb-item">
      <a *ngIf="item.link && !last; else current" [routerLink]="item.link" [queryParams]="item.queryParams">{{
        item.translate ? (item.label | lhTranslate: lang) : item.label
      }}</a>
      <ng-template #current>
        <span aria-current="page">{{ item.translate ? (item.label | lhTranslate: lang) : item.label }}</span>
      </ng-template>
    </li>
  </ol>
</nav>
